;(function( $ ) {
    'use strict';

    function isImageLink( i, node ) {
        var $node = $( node ),
            search = $node.get( 0 ).search, // The search string
            hash = $node.get( 0 ).hash,
            href = $node.prop( 'href' ).replace( search, '' ).replace( hash, '' ); // The link without the search string or hash.

        // Only links that point to images or videos
        return href.match( /\.(jpg|jpe|jpeg|png|gif|bmp|m4v|mp4)$/ );
    }

    function isVideoLink( i, node ) {
        var $node = $( node ),
            search = $node.get( 0 ).search, // The search string
            hash = $node.get( 0 ).hash,
            href = $node.prop( 'href' ).replace( search, '' ).replace( hash, '' ); // The link without the search string or hash.

        return href.match( /^https?:\/\/(?:www\.)?(?:youtube\.com\/watch|youtu\.be\/)/i ) || href.match( /^https?:\/\/(.+\.)?vimeo\.com\/.*/i );
    }


    $( document ).ready( function() {
        // Move the align class from the image down to the anchor wrapping the image
        $( '.article-body a[rel^="attachment"], .article-body a[rel*=" attachment"]' )
            .each( function( i, e ) {
                var $this = $( this ),
                    $child = $this.children( 'img.alignleft, img.alignright' );

                if ( $child.length ) {
                    if ( $child.hasClass( 'alignleft' ) ) {
                        $this.addClass( 'alignleft' );
                        $child.removeClass( 'alignleft' );
                    }
                    else {
                        $this.addClass( 'alignright' );
                        $child.removeClass( 'alignright' );
                    }
                }
            } );

        $( '.tabbed' ).each( function() {
            var $this = $( this ),
                $tabs = $this.find( '> .tabs > a' ),
                $page = $this.find( '> article' );

            $tabs.each( function( i ) {
                $( this ).on( 'click', function( e ) {
                    e.preventDefault();
                    $( $tabs.removeClass( 'active' ).get( i ) ).addClass( 'active' );
                    $( $page.removeClass( 'active' ).get( i ) ).addClass( 'active' );
                } );
            } );

        } );

        // Auto adjust iFrame according to content
//        $( '.widget iframe' ).iFrameResize( [{
//            autoResize: true,
//            log: false
//        }] );

        $( '.modal-me' )
            .not( isImageLink ) // We're not looking for image
            .not( isVideoLink ) // And we definitely don't want videos
            .featherlight(
                {
                    type: 'iframe',
                    iframeWidth: Math.min( Math.max( $( window ).width() * 0.90, 300 ), 1024 ), // 90 of the screen width upto 1024 wide
                    iframeHeight: 100,// and the height has a small initial before being resized,
                    iframeAllowfullscreen: 'yes',
                    iframeFrameborder: 'no',
                    iframeScrolling: 'yes',
                    afterOpen: function() {
                        $( '.featherlight-content iframe' ).iFrameResize( [{
                            autoResize: true,
                            log: false,
                            inPageLinks: true
                        }] );
                    }
                }
            )
            .end() // End the video filter
            .end() // End the Image filter
            .filter( isImageLink ) // Now we'll look at the image
            .featherlight( { type: 'image' } );

        // For the moment linking to youtube of vimeo will result in no modal at all.
        // Videos are a bit broken in feather light, easier to just embed them in a post and point at that.
        // .end();
        // .filter( isVideoLink )
        // .featherlight( { type: 'iframe' } );

        // Check that IntersectionObserver is available to this browser then watch the header to see when it becomes sticky.
        if ( !!window.IntersectionObserver ) {
            let header = document.querySelector( '#navigation' ),
                observer = new IntersectionObserver( ( [e] ) => {
                    header.classList.toggle( 'is-sticky', e.boundingClientRect.top < 1 );
                }, { threshold: [0], rootMargin: '0px 0px -100%' } );

            if ( header !== null ) {
                observer.observe( header.nextElementSibling );
            }
        }
    } );
}( jQuery ));
